import _ from 'lodash';

export const DEFAULT_AVATAR = "/static/avatar.jpg";

export const ChartType = {
    Type1: "G",
    Type2: "2",
    Type3: "3",
};

function random(min, max) {
    return Math.round(Math.random() * (max - min)) + min;
}

export const TestData = [
    {
        points: [[125, -10], [200, 0], [400, 0], [490, 3], [1500, 8], [1600, 13], [2000, 18], [3000, 21], [5500, 17], [8000, 14], [9600, 0]],
        name: ChartType.Type1,
    },
    {
        points: [[125, -10], [200, 0], [400, 0], [490, 0], [1500, 4], [1600, 11], [2000, 10], [3000, 11], [5500, 15], [8000, 24], [9600, 0]],
        name: ChartType.Type1,
    },
    {
        points: [[125, -10], [200, 0], [400, 0], [490, 4], [1500, 5], [1600, 16], [2000, 20], [3000, 11], [5500, 5], [8000, 4], [9600, 0]],
        name: ChartType.Type1,
    },
    {
        points: [[125, -10], [200, 32], [400, 18], [490, 28], [1500, 18], [1600, 32], [2000, 13], [3000, 52], [5500, 48], [8000, 50], [9600, 18]],
        name: ChartType.Type2,
    },
    {
        points: [[125, -10], [200, 32], [400, 18], [490, 28], [1500, 18], [1600, 42], [2000, 23], [3000, 62], [5500, 58], [8000, 60], [9600, 28]],
        name: ChartType.Type3,
    },
];

export const TestCompressData = [
    {
        points: [[125, -10], [200, 32], [400, 18], [490, 28], [1500, 18], [1600, 42], [2000, 23], [3000, 62], [5500, 58], [8000, 60], [9600, 28]],
        name: "compressratio",
    },
]
    ;
export const TestIOData = [
    {
        points: [[20, 42], [40, 61], [60, 82], [80, 90], [100, 98], [120, 98], [140, 98]],
        name: "Output",
    },
    {
        points: [[20, 96], [140, 96]],
        name: "mpo",
    },
    {
        points: [[20, 68], [70, 112], [140, 112]],
        name: "EffectLimitations",
    },
];

export const TestNoiseData =
{
    points: [[189, 0], [250, 32], [500, 42], [1000, 45], [2000, 71], [4000, 51], [8000, 47], [9600, 43]],
    name: "Noise",
};

export const TestRatioData = [
    {
        points: [[0, 1], [1, 1], [2, 1.4], [3, 1.6], [4, 1.2], [5, 1.3], [6, 1.0], [6.5, 1.0]],
        name: "compressratio",
    },
];

export function GetTestData() {
    let newData = _.cloneDeep(TestData);
    for (let data of newData) {
        for (let i = 0; i < data.points.length; i++) {
            if (i > 2) {
                let pt = data.points[i];
                let dir = (Date.now() & 1) ? 1 : -1;
                let fuzz = random(0, 8) * dir;
                pt[1] += fuzz;
            }
        }
    }
    return newData;
}
export function GetTestIOData() {
    let newData = _.cloneDeep(TestIOData);
    for (let data of newData) {
        for (let i = 0; i < data.points.length; i++) {
            if (i > 2) {
                let pt = data.points[i];
                let dir = (Date.now() & 1) ? 1 : -1;
                let fuzz = random(0, 20) * dir;
                pt[1] += fuzz;
            }
        }
    }
    return newData;
}